// pc观看端右侧聊天区域容器组件
import VmpBasicRightContainerLive from './src/main';

/* istanbul ignore next */
VmpBasicRightContainerLive.install = function (Vue) {
  Vue.component(VmpBasicRightContainerLive.name, VmpBasicRightContainerLive);
};

export default VmpBasicRightContainerLive;
